import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import {
    SwalError,
    SwalFormWarning,
    SwalWarning,
} from '../../Services/_swal.service';
import BeforeUnloadComponent from 'react-beforeunload-component';
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import { blockRoute } from '../../redux/actions/helper/helper.actions';
import {
    createReport,
    handleInputChange,
    setPage,
    testReport,
} from '../../redux/actions/reports/reports.actions';

function ReportCreateGlobal({
    report: { single_report, main_report_page, main_url, test_result },
    handleInputChange,
    createReport,
    pageOrigin,
    blockRoute,
    block_route,
    setPage,
    testReport,
}) {
    let history = useHistory();

    useEffect(() => {
        blockRoute(false);
        setPage('main_report_page', null, false);
    }, []);

    useEffect(() => {
        if (block_route) {
            window.history.pushState(null, null, window.location.pathname);
            window.addEventListener('popstate', onBackButtonEvent);
        }

        return () => {
            window.removeEventListener('popstate', onBackButtonEvent);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [block_route]);

    const onBackButtonEvent = (e) => {
        e.preventDefault();
        if (block_route) {
            SwalFormWarning(
                'Warning',
                'Do you want to leave without saving',
                () => goLastLocation(),
                () => blockAgain()
            );
        }
    };

    const goLastLocation = () => {
        history.goBack();
        blockRoute(false);
    };

    const blockAgain = () =>
        window.history.pushState(null, null, window.location.pathname);

    if (main_report_page) return <Redirect to={main_url} />;

    return (
        <Fragment>
            <BeforeUnloadComponent
                blockRoute={block_route}
                ignoreBeforeunloadDocument={true}
                modalComponentHandler={({
                    handleModalLeave,
                    handleModalCancel,
                }) => {
                    SwalFormWarning(
                        'Warning',
                        'Do you want to leave without saving',
                        () => handleModalLeave(),
                        () => handleModalCancel()
                    );
                }}
            >
                <form onSubmit={(e) => createReport(e, pageOrigin)}>
                    <section>
                        <div className="col-12 row">
                            <div className="col-4">
                                <label className="label-control f-small">
                                    Report Name:{' '}
                                    <span className="text-danger">*</span>
                                </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <input
                                            onChange={(e) =>
                                                handleInputChange(e)
                                            }
                                            type="text"
                                            name="name"
                                            className="form-control"
                                            placeholder="Report Name"
                                            required
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>{' '}
                            <div className="col-4">
                                <label className="label-control f-small">
                                    Description:
                                </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <textarea
                                            onChange={(e) => {
                                                handleInputChange(e);
                                            }}
                                            name="description"
                                            rows="2"
                                            className="form-control"
                                            placeholder="Description"
                                        ></textarea>
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-4"></div>
                            <div className="col-4">
                                <label className="label-control f-small">
                                    Collection:{' '}
                                    <span className="text-danger">*</span>
                                </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <input
                                            onChange={(e) =>
                                                handleInputChange(e)
                                            }
                                            type="text"
                                            name="collection"
                                            className="form-control"
                                            placeholder="Collection"
                                            required
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>{' '}
                        </div>
                        <div className="col-12 row">
                            {' '}
                            <div className="col-6">
                                <div>
                                    {' '}
                                    <label className="label-control f-small">
                                        Query:
                                    </label>
                                    <div className="form-group row">
                                        <div className="col-md-11 col-10">
                                            <textarea
                                                onChange={(e) => {
                                                    handleInputChange(e);
                                                }}
                                                name="query"
                                                rows="10"
                                                className="form-control"
                                                placeholder="Query"
                                            ></textarea>
                                        </div>
                                        <div className="float-right pl-0 col-1 col-md-1">
                                            <div className="input-group-prepend">
                                                <span
                                                    href="#"
                                                    className="tool-tip text-primary"
                                                    data-tip="this is a tool tip"
                                                >
                                                    <i className="la la-question-circle"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="text-right"
                                    style={{ marginRight: '50px' }}
                                >
                                    <button
                                        className="btn btn-danger btn-save"
                                        onClick={(e) => testReport(e)}
                                    >
                                        Test Report
                                    </button>
                                </div>
                            </div>
                            <div className="col-6">
                                {' '}
                                <label className="label-control f-small">
                                    Console:
                                </label>
                                <div className="form-group row">
                                    <div className="col-md-11 col-10">
                                        <textarea
                                            name="query"
                                            rows="10"
                                            className="form-control bg-dark text-white"
                                            placeholder="Query"
                                            value={JSON.stringify(
                                                test_result,
                                                null,
                                                2
                                            )}
                                            disabled
                                        />
                                    </div>
                                    <div className="float-right pl-0 col-1 col-md-1">
                                        <div className="input-group-prepend">
                                            <span
                                                href="#"
                                                className="tool-tip text-primary"
                                                data-tip="this is a tool tip"
                                            >
                                                <i className="la la-question-circle"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group row">
                                <div className="col-md-8 col-12 label-control f-regular"></div>
                                <div className="col-md-4 col-12 text-right">
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-save"
                                    >
                                        Save Report
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                </form>
            </BeforeUnloadComponent>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    report: state.report,
    block_route: state.helper.block_route,
});

export default connect(mapStateToProps, {
    handleInputChange,
    createReport,
    blockRoute,
    setPage,
    testReport,
})(ReportCreateGlobal);
